import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Everything the business sells, each part a tab. It gives the breadcrumb its "Offer" step. */
export const Route = createFileRoute("/(private)/offer")({
  loader: () => ({ crumb: m.offer_nav_label() }),
  component: Outlet,
});
